<template>
  <loader :is-loading="loading" color="primary">
    <v-flex>
      <v-alert
        :value="invalidCallback"
        type="error"
      >
        {{ $t('authentication.error') }}
      </v-alert>
    </v-flex>
  </loader>
</template>
<script>
import { Authentication } from '@icabbi/vue-authentication';
import { mapGetters } from 'vuex';
import environment from '@/environment';
import { RoutePath } from '@/routing/routePath';
import { bookingChannelComputed } from '../../mixins/bookingChannel.mixins';

export default {
  name: 'OAuthCallbackView',
  mixins: [bookingChannelComputed],
  async mounted() {
    this.loading = true;

    if (this.isValidCallback(this.$route.query)) {
      const redirectPath = this.loginContext.to.path;

      await this.performLogin();

      this.loading = false;

      await this.$store.dispatch('authentication/clearLoginContext');

      // Authentication flow completed. Navigate away.
      await this.$router.push({
        path: redirectPath,
      });
    } else {
      this.loading = false;
      await this.$store.dispatch('globalError/setAuthError', { message: this.getError(this.$route.query) });
      await this.$router.push(RoutePath.GET_STARTED_PATH);
    }
  },
  data() {
    return {
      invalidCallback: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      loginContext: 'authentication/loginContext',
      token: 'authentication/token',
    }),
  },
  methods: {
    isValidCallback(query) {
      return query.state
          && this.loginContext
          && this.loginContext.state
          && !query.error
          && query.state === this.loginContext.state;
    },
    async performLogin() {
      if (environment.isInMockApiMode()) {
        await this.$store.dispatch('authManager/mockLogin');
      } else {
        await Authentication(this.$store).exchangeCodeForToken(this.$route.query.code, this.loginContext, this.oidcClientId, this.authCallbackUrl);
      }
    },
    getError(query) {
      if (query.error) {
        return query.error_description;
      }
      if (!this.loginContext || !this.loginContext.state) {
        return this.$t('pages.oauthcallback.invalidContext');
      }
      if (!query.state || !(query.state === this.loginContext.state)) {
        return this.$t('pages.oauthcallback.invalidState');
      }
      return this.$t('pages.oauthcallback.error');
    },
  },
};
</script>

<style scoped>
</style>
